/*
  Tienda mentor · Ficha: elección de color/talla, precio y «−X %» al cambiar, stock real bajo, galería con puntos,
  añadir al carrito con el mismo evento que el tema (abre el carrito lateral) y botón fijo abajo.
*/
import { CartLinesUpdateEvent } from '@shopify/events';

const initPdp = (root) => {
  if (root.dataset.lcReady) return; // una sola vez por ficha (evita eventos duplicados)
  root.dataset.lcReady = '1';
  const $ = (s) => root.querySelector(s);
  const data = JSON.parse($('[data-lc-json]').textContent);
  const fmt = (c) => {
    const n = (c / 100).toFixed(2), [i, d] = n.split('.');
    const withDots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return data.money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${withDots},${d}`).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, i);
  };
  const form = $('[data-lc-form]'), idIn = $('[data-lc-id]'), atc = $('[data-lc-atc]'), msg = $('[data-lc-msg]');
  const was = $('[data-lc-was]'), now = $('[data-lc-now]'), badge = $('[data-lc-badge]'), promo = $('[data-lc-promo]');
  const trust = $('[data-lc-trust]');
  const stock = $('[data-lc-stock]'), stockTxt = $('[data-lc-stocktxt]'), optval = $('[data-lc-optval]');
  const slides = $('[data-lc-slides]'), dotsBox = $('[data-lc-dots]');
  let dots = [...root.querySelectorAll('[data-lc-dots] button')];

  // Galería por color. Fuentes, por orden: mapa del tema (vrs-gallery-map: «idValor:Nombre=>idFoto,…||*=>comunes»; por id
  // del valor y, si no, por nombre), etiqueta [vrs-color:…] del texto alternativo y orden de fotos marcado por las fotos
  // destacadas de las variantes. Nombres comparados sin tildes, mayúsculas, espacios ni guiones. Sin relación fiable: todas.
  const norm = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[\s_-]+/g, ' ').trim();
  const colorIdx = [...root.querySelectorAll('[data-lc-opt]')].findIndex((f) => f.querySelector('.lc-opt__vals--sw'));
  const allSlides = slides ? [...slides.querySelectorAll('.lc-pdp__slide')] : [];
  const byMedia = new Map(allSlides.map((s) => [s.dataset.mediaId, s]));
  const gById = {}, gByName = {}; let common = new Set();
  (data.gallery || '').split('||').forEach((e) => {
    const m = e.match(/^\s*(?:(\d+):)?(.+?)=>(.*)$/); if (!m) return;
    const ids = new Set(m[3].split(',').map((s) => s.trim()).filter(Boolean));
    if (m[2].trim() === '*') { common = ids; return; }
    if (m[1]) gById[m[1]] = ids;
    gByName[norm(m[2])] = ids;
  });
  const byOrder = {};
  if (colorIdx > -1) {
    // Cada color empieza en la foto destacada de sus variantes y llega hasta la del color siguiente (solo si el primero empieza en la primera foto).
    const start = {};
    data.variants.forEach((v) => { const k = norm(v.options[colorIdx]), s = byMedia.get(String(v.media)); if (s && !(k in start)) start[k] = allSlides.indexOf(s); });
    const colors = new Set(data.variants.map((v) => norm(v.options[colorIdx])));
    const sorted = Object.entries(start).sort((a, b) => a[1] - b[1]);
    if (colors.size > 1 && sorted.length === colors.size && new Set(sorted.map((e) => e[1])).size === sorted.length && sorted[0][1] === 0) {
      sorted.forEach(([k, i], n) => { byOrder[k] = allSlides.slice(i, n + 1 < sorted.length ? sorted[n + 1][1] : allSlides.length); });
    }
  }
  function slidesFor(color) {
    const key = norm(color), vid = (data.colorIds || {})[color];
    for (const set of [vid && gById[vid], gByName[key]]) {
      if (!set) continue;
      const show = allSlides.filter((s) => set.has(s.dataset.mediaId) || common.has(s.dataset.mediaId));
      if (show.some((s) => set.has(s.dataset.mediaId))) return show;
    }
    const tagged = allSlides.filter((s) => s.dataset.color && norm(s.dataset.color) === key);
    if (tagged.length) return tagged;
    return byOrder[key] || allSlides; // sin fotos asignadas a ese color: se ven todas
  }
  let lastColor = null;
  function filterGallery(color, mediaId) {
    if (!slides || color == null) return;
    const key = norm(color);
    if (key === lastColor) return; lastColor = key; // cambio de talla: se queda el color y su galería
    const show = slidesFor(color);
    allSlides.forEach((s) => { s.hidden = !show.includes(s); });
    const at = Math.max(0, show.indexOf(byMedia.get(String(mediaId))));
    slides.scrollTo({ left: slides.clientWidth * at });
    if (dotsBox) {
      dotsBox.innerHTML = show.length > 1 ? show.map((_, i) => `<button type="button" aria-label="Foto ${i + 1}"${i === at ? ' class="is-on"' : ''}></button>`).join('') : '';
      dots = [...dotsBox.querySelectorAll('button')];
      dots.forEach((d, i) => d.addEventListener('click', () => slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' })));
    }
  }

  const current = () => [...root.querySelectorAll('[data-lc-opt]')].map((f) => f.querySelector('input:checked')?.value);
  const find = () => { const sel = current(); return data.variants.find((v) => v.options.every((o, i) => o === sel[i])); };

  function paint() {
    const v = find();
    root.querySelectorAll('[data-lc-opt]').forEach((f, i) => {
      const ov = f.querySelector('[data-lc-optval]'); if (ov) ov.textContent = f.querySelector('input:checked')?.value || '';
      // Tachar los valores sin stock para la combinación actual
      const sel = current();
      f.querySelectorAll('input').forEach((inp) => {
        const test = sel.slice(); test[i] = inp.value;
        const ok = data.variants.some((x) => x.available && x.options.every((o, k) => o === test[k]));
        inp.closest('.lc-opt__btn, .lc-opt__sw').classList.toggle('is-out', !ok);
      });
    });
    if (colorIdx > -1) filterGallery(current()[colorIdx], v && v.media); // también si la combinación no existe
    if (!v) { atc.disabled = true; atc.textContent = 'NO DISPONIBLE'; return; }
    idIn.value = v.id;
    now.textContent = fmt(v.price);
    const sale = v.compare > v.price;
    was.hidden = !sale; if (sale) was.textContent = fmt(v.compare);
    now.classList.toggle('is-sale', sale);
    if (promo) promo.hidden = !sale;
    badge.hidden = !sale; if (sale) badge.textContent = `-${Math.round((v.compare - v.price) * 100 / v.compare)}%`;
    if (trust) {
      const sv = trust.querySelector('[data-lc-save]');
      sv.hidden = !sale; if (sale) trust.querySelector('[data-lc-save-amt]').textContent = fmt(v.compare - v.price);
      trust.querySelectorAll('[data-lc-each]').forEach((e) => { e.textContent = `${fmt(v.price - Math.floor(v.price * Number(e.dataset.lcEach) / 100))}/ud.`; }); // igual que Shopify: descuento truncado al céntimo
    }
    atc.disabled = !v.available; atc.textContent = v.available ? 'AÑADIR AL CARRITO' : 'AGOTADO';
    const stSave = root.querySelector('[data-lc-pdp-save]');
    if (stSave) { stSave.hidden = !sale; if (sale) stSave.querySelector('[data-lc-pdp-save-amt]').textContent = fmt(v.compare - v.price); }
    const stPrice = root.querySelector('[data-lc-sticky-price]');
    if (stPrice) stPrice.textContent = fmt(v.price);
    const low = v.qty != null && v.available && v.qty > 0 && v.qty <= data.lowStock;
    stock.hidden = !low; if (low) stockTxt.textContent = v.qty === 1 ? '¡Solo queda 1 disponible!' : `¡Solo quedan ${v.qty} disponibles!`;
    if (colorIdx < 0 && v.media && slides) { const s = slides.querySelector(`[data-media-id="${v.media}"]`); if (s) slides.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
  }
  // Fecha estimada de entrega: hoy + días laborables (lun–vie) configurados en la sección.
  const eta = trust && trust.querySelector('[data-lc-eta]');
  if (eta) {
    const addWork = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6) k++; } return d; };
    const f = (d) => d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/[.,]/g, '');
    eta.textContent = `Pídelo hoy y llega entre el ${f(addWork(+trust.dataset.dmin))} y el ${f(addWork(+trust.dataset.dmax))}`;
  }
  root.addEventListener('change', (e) => { if (e.target.matches('[data-lc-opt] input')) paint(); });
  paint();

  // Galería
  if (slides) {
    slides.addEventListener('scroll', () => { const i = Math.round(slides.scrollLeft / slides.clientWidth); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }, { passive: true });
    if (colorIdx < 0) dots.forEach((d, i) => d.addEventListener('click', () => slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' })));
  }

  // Añadir al carrito
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const id = Number(idIn.value); if (!id || atc.disabled) return;
    atc.disabled = true; atc.setAttribute('aria-busy', 'true'); msg.textContent = '';
    const deferred = CartLinesUpdateEvent.createPromise();
    atc.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
    try {
      const res = await fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer-section', sections_url: location.pathname }) });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'No se pudo añadir.');
      const cart = await (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: json.sections, items: cart.items, itemCount: cart.item_count, source: 'lc-product', didError: false } });
      document.querySelectorAll('[data-lc-count]').forEach((n) => { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
      const drawer = document.getElementById('cart-drawer'); if (drawer && !drawer.isOpen && typeof drawer.open === 'function') drawer.open();
    } catch (err) {
      deferred.reject(err);
      msg.textContent = err instanceof Error ? err.message : 'No se pudo añadir.';
    } finally {
      atc.removeAttribute('aria-busy'); paint();
    }
  });

  // Botón fijo abajo cuando el principal no se ve
  const sticky = $('[data-lc-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }, { threshold: 0 }).observe(atc);
    sticky.querySelector('[data-lc-sticky-btn]').addEventListener('click', () => { if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } form.requestSubmit(); });
  }
};
document.querySelectorAll('[data-lc-pdp]').forEach(initPdp);
// El editor del tema vuelve a pintar la sección sin recargar la página.
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-lc-pdp]').forEach(initPdp));
